namespace TabAurous.Inventory {
    export interface LocationTransferRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        AutoPosting?: boolean;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        BillAddId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        ItemDetails?: LocationTransferItemsRow[];
        FromDepartmentId?: number;
        ToDepartmentId?: number;
        RoundOff?: number;
        FromDepartmentName?: string;
        ToDepartmentName?: string;
        PostingDate?: string;
        IsPosted?: boolean;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        Username?: string;
    }

    export namespace LocationTransferRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Inventory.LocationTransfer';
        export const deletePermission = 'Inventory:LocationTransfer:Delete';
        export const insertPermission = 'Inventory:LocationTransfer:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:LocationTransfer:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            AutoPosting = "AutoPosting",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            BillAddId = "BillAddId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            ItemDetails = "ItemDetails",
            FromDepartmentId = "FromDepartmentId",
            ToDepartmentId = "ToDepartmentId",
            RoundOff = "RoundOff",
            FromDepartmentName = "FromDepartmentName",
            ToDepartmentName = "ToDepartmentName",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            Username = "Username"
        }
    }
}
